import { userConstants } from "../../constants/ActionTypes";


const initialState = {
   list:[]
};

const addUser_initialState={
    fullname:"",
    email:"",
    password:"",
    confirmPassword:"",
    phone:"",
    role:[],
    role_name:"",
    role_code:"",
    showPassword:false,
    showConfirmPassword:true,
    merchantrouteList:[],
    privileges:[]
    
}

const editUser_nitialState = {
    subUserdetailList:[],
    edit_fullname:"",
    edit_email:"",
    edit_phone:"",
    edit_privilages:[],
    roleId:""

 };
export function user_list(state = initialState, action) {
    switch (action.type) {  
        case userConstants.USERS:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state
    }
}

export function addUser( state = addUser_initialState,action){
    switch (action.type) {  
        case userConstants.ADDUSERS:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state
    }
}

export function editUser( state = editUser_nitialState,action){
    switch (action.type) {  
        case userConstants.EDITUSERS:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state
    }
}